import { classnames } from '@aibees/shared/utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsTreemap from 'highcharts/modules/treemap';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TreeMapChartProps as Props } from './types';

highchartsTreemap(Highcharts);

export const TreeMapChart = memo(({ className, options }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('TreeMapChart', className)}
      sx={SX.root}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Styled.Wrapper>
  );
});

TreeMapChart.displayName = 'TreeMapChart';
